import React, { useState } from "react";
import { Link } from "react-router-dom";
import TitleSearchComponent from "../../components/Global/TitleSearchComponent";
import { Button, Grid, makeStyles } from "@material-ui/core";
import { User, UserRole } from "../../domain/domain";
import { ApplicationState } from "../../reducers";
import { compose } from "redux";
import { connect } from "react-redux";
import UserMenu from "./UserMenu";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';

const useStyles = makeStyles(_ => ({
    root: {
        borderBottom: "1px solid #2e9e9e"
    },
    link: {
        textDecoration: 'none',
        textTransform: 'uppercase',
        color: '#1f6a6a',
        fontWeight: 700,
        fontSize: '0.875rem',
        whiteSpace: 'nowrap',
        transition: 'all .15s ease-in-out',
        '&:hover': {
            textDecoration: 'underline',
            textUnderlineOffset: "2px",
        }
    },
    disabledLink: {
        textDecoration: 'none',
        textTransform: 'uppercase',
        color: 'gray',
        fontWeight: 700,
        fontSize: '0.875rem',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
    },
    rootNoLinks: {
        borderBottom: 'none'
    },
    'dev-env': {
       backgroundColor: '#d6f0fa'
    },
    'uat-env': {
        backgroundColor: '#fff2cc'
    },
    envLabel: {
        position: 'absolute',
        top: 6,
        right: 24,
        fontSize: 13,
        fontWeight: 700,
        padding: '2px 8px',
        borderRadius: 4,
        backgroundColor: '#2f3a4a',
        color: '#ffffff',
        textTransform: 'uppercase',
    }
}));

type Props = {
    showLinks: boolean,
    currentUser: User
}

type BuildEnv = 'uat' | 'prod' | 'dev';

const Header: React.FC<Props> = ({ showLinks, currentUser }) => {
    const classes = useStyles();
    const [userMenuOpen, setUserMenuOpen] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<any>();

    const isLinkDisabled = currentUser?.userRole === UserRole.NON_PUBLICATIONS_TEAM;
    const appEnv = process.env.REACT_APP_ENVIRONMENT as BuildEnv;
    const envClass = `${appEnv}-env` as keyof typeof classes;

    return (
        <>
            <UserMenu open={userMenuOpen} anchorEl={anchorEl} onMenuClosed={() => {
                setUserMenuOpen(false);
            }} />
            {['dev', 'uat'].includes(appEnv) && (
                <span className={classes.envLabel}>
                    {appEnv}
                </span>
            )}
            <Grid container direction='row' className={clsx(showLinks ? classes.root : classes.rootNoLinks, classes[envClass], "flex-gap-1")} justifyContent="center" alignItems='center'>
                <Grid item>
                    <Link to="/">
                        <img className="app-logo app-logo--header" src="/images/xd-logo.png" alt="XDOME" />
                    </Link>
                </Grid>
                {showLinks &&
                    <>
                        <Grid item>
                            <Link className={classes.link} to={"/component"}>Provision Mgmt</Link>
                        </Grid>
                        <Grid item>
                            <Link
                                className={isLinkDisabled ? classes.disabledLink : classes.link}
                                to={isLinkDisabled ? '#' : '/red-book'}
                                onClick={(e) => {
                                    if (isLinkDisabled) {
                                        e.preventDefault();
                                    }
                                }}
                            >
                                Red Book
                            </Link>
                        </Grid>
                        <Grid item>
                            <Link
                                className={isLinkDisabled ? classes.disabledLink : classes.link}
                                to={isLinkDisabled ? '#' : '/status'}
                                onClick={(e) => {
                                    if (isLinkDisabled) {
                                        e.preventDefault();
                                    }
                                }}
                            >
                                Titles
                            </Link>
                        </Grid>
                        <Grid item>
                            <TitleSearchComponent />
                        </Grid>
                    </>
                }
                <Grid item>
                    <Button onClick={(event: any) => {
                        setUserMenuOpen(true);
                        setAnchorEl(event.currentTarget);
                    }}><ExpandMoreIcon />{currentUser.firstName} {currentUser.lastName}</Button>
                </Grid>
            </Grid>
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => {
    return { currentUser: state.user.currentUser };
};

const mapDispatchToProps = (dispatch: any) => {
    return { dispatch };
}

export default compose<any>(
    connect(mapStateToProps, mapDispatchToProps)
)(Header);
